import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {appInjector} from "../../../index";
import {NewBarcodeFormComponent} from "../../../identity/new-barcode-form/new-barcode-form.component";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {StockService} from "../../services/stock.service";
import {Stock} from "../../../shared/view-model/stock";
import {STOCK_ITEM_EXISTS_IN_DEPOT_ERROR} from "./validate-stock-item-not-exists.directive";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {ApolloQueryObservable} from "apollo-angular";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {StockItem} from "../../../shared/view-model/store-management/stock-item.type";
import {FetchStockItemsResult, StockItemService} from "../../services/stock-item-service/stock-item.service";
import {DepotYard} from "../../../shared/view-model/store-management/depot-yard.type";
import {DepotService} from "../../services/depot-service/depot.service";

@Component({
  selector: 'vb-add-stocks-table-view',
  templateUrl: './add-stocks-table-view.component.html',
  styleUrls: ['./add-stocks-table-view.component.css']
})
export class AddStocksTableViewComponent extends AbstractVisbosComponent implements OnInit {

  STOCK_ITEM_EXISTS_IN_DEPOT_ERROR;

  control: FormGroup;
  stocksCtrl: FormArray;

  stockItemList$: ApolloQueryObservable<FetchStockItemsResult>;
  stockItemList: StockItem[];
  stockItemLoading: boolean = true;

  TrackByFunction = (index, item) => {
    return item.get('cuid').value;
  };

  private stocksInDepot$: ApolloQueryObservable<Stock[]>;
  stocksInDepot: Stock[] = [];

  private depotYards$: ApolloQueryObservable<DepotYard[]>;
  depotYards: DepotYard[];
  depotYardLoading: boolean = true;

  constructor(private fb: FormBuilder,
              private stockService: StockService, private stockItemService: StockItemService,
              private depotService: DepotService,
              sessionActions: SessionActions, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
    this.STOCK_ITEM_EXISTS_IN_DEPOT_ERROR = STOCK_ITEM_EXISTS_IN_DEPOT_ERROR;
  }

  ngOnInit() {
    this.control = AddStocksTableViewComponent.initControl(this.fb);
    this.stocksCtrl = <FormArray>this.control.get('stocks');

    this.stocksInDepot$ = this.stockService.getStocksForDepot(this.control.get('depot_id').valueChanges);
    this.dataSubscriptions.push(this.stocksInDepot$.subscribe((st: any) => {
        this.stocksInDepot = st;
      })
    );

    this.depotYards$ = this.depotService.getDepotYards(this.control.get('depot_id').valueChanges);
    this.dataSubscriptions.push(this.depotYards$.subscribe((res: any) => {
      this.depotYards = res;
      this.depotYardLoading = false;
    }));

    this.stockItemList$ = this.stockItemService.fetchStockItemsWithDetails();
    this.dataSubscriptions.push(
      this.stockItemList$.subscribe(res => {
        this.stockItemList = res.data.fetchStockItems;
        this.stockItemLoading = false;
      })
    );

    this.addStock();
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      depot_id: [null, Validators.required],
      stocks: fb.array([])
    });

  }

  private static initStock(fb: FormBuilder) {
    let ctrl = fb.group({
      cuid: [AbstractVisbosControl.cuid(), Validators.required],
      stock_item_id: [null, Validators.required],
      depot_yard_id: [null],
      name: [null],
      min_stock: [null, Validators.required],
      report_stock: [null],
      shall_stock: [null, Validators.required],
      act_stock: [0, Validators.required],
      extraction_amount: [1, Validators.required],
      order_amount: [null],
      registration_required: [false, Validators.required],
      ean: NewBarcodeFormComponent.initControl(fb), // Necessary for async validator
      product_batches: fb.array([]),
    });

    return ctrl;
  }

  addStock() {
    let st = AddStocksTableViewComponent.initStock(this.fb);
    this.stocksCtrl.push(st);
    //this.cd.markForCheck();
  }

  deleteStock(index) {
    this.stocksCtrl.removeAt(index);
    //this.cd.markForCheck();
  }

  saveStocks() {
    this.stockService.createStocksForDepot(this.control.get('depot_id').value, this.control.get('stocks').value).toPromise()
      .then((res: any) => {
        this.sessionActions.pushMessage('Bestände wurden erfolgreich angelegt!', MessageType.SUCCESS, 'Bestandsverwaltung');
        this.reloadComponent();
      })
      .catch(err => {
        this.sessionActions.pushMessage("Fehler beim Speichern der Bestände!", MessageType.ERROR, "Bestandsverwaltung");
      });
  }

  reloadComponent() {
    this.control = AddStocksTableViewComponent.initControl(this.fb);
    this.stocksCtrl = <FormArray>this.control.get('stocks');
    //this.cd.markForCheck();
    this.addStock();
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/add-stocks-table-view/add-stocks-table-view.component.ts